<template>
  <div v-if="!hideHead" class="rt-header rt-crm-header plat-crm-header">
    <h2 class="plat-crm-header-title">{{ title }}</h2>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'RtPlatHeader',
  props: {
    title: {
      type: String,
      default: '',
      required: true
    },
    hideTag: {
      type: Boolean,
      default: null,
      required: false
    }
  },
  computed: {
    hideHead() {
      if (this.hideTag) {
        return !this.hideTag;
      }
      return this.$route.name === 'ApproveCenter';
    }
  }
};
</script>

<style lang="scss" scoped>
.rt-header.plat-crm-header {
  margin-bottom: 12px;
  line-height: 36px;
  background-color: #fff;
  min-height: 36px;
  z-index: 10;
  position: relative;
  .plat-crm-header-title {
    font-size: 14px;
    font-weight: 700;
    display: inline;
    color: #555;
    border-left: 2px solid #1fb6d8;
    padding-left: 20px;
  }
  .rt-toolbar {
    position: absolute;
    right: 8px;
    top: 4px;
  }
}
</style>



// WEBPACK FOOTER //
// main.vue?ff182ad6